define(['jquery', 'jqueryUi', 'jqueryMultiDatePicker'], function($) {
    var AJAX_URL = '/wp-admin/admin-ajax.php';
    var onChange;
    var get = function() {
        return {
            check_in_date: $('[name="check_in_date"]').val(),
            check_out_date: $('[name="check_out_date"]').val(),
            adults: $('[name="number_of_adults"]').val(),
            children: $('[name="number_of_children"]').val(),
            promo: $('[name="promo_code"]').val()
        };
    };

    var getDirectOfferCode = function() {
        return $('[name="offer-on-load"]').val();
    };

    var clearDirectOfferCode = function() {
        $('[name="offer-on-load"]').val('');
    };

    $('[name="check_in_date"]').datepicker({
        dateFormat: 'DD, d MM, yy',
        minDate: '0'
    });

    $('[name="check_out_date"]').datepicker({
        dateFormat: 'DD, d MM, yy',
        minDate: '+1'
    });

    $('section.check-in input, section.check-in select').change(function() {
        if ($('[name="number_of_children"]').val() == '3') {
            $('.booking-message').removeClass('hidden');
            return false;
        } else {
            $('.booking-message').addClass('hidden');
        }
        var checkInDate = new Date($('[name="check_in_date"]').val());
        var checkOutDate = new Date($('[name="check_out_date"]').val());

        if (checkOutDate.getTime() <= checkInDate.getTime()) {
            $('[name="check_out_date"]').datepicker("setDate", new Date(checkInDate.getTime() + 24 * 60 * 60 * 1000));
        }

        if ($.isFunction(onChange)) {
            onChange();
        }
    });

    $('[data-role="toggle-promo-code"]').click(function() {
        var $button = $(this);
        var $error = $('.promo .error');
        var $promoCodeInput = $('[name="promo_code_input"]');
        var $promoCode = $('[name="promo_code"]');

        $error.addClass('hide');

        if ($promoCode.val()) {
            //remove code
            $promoCodeInput.val('');
            $promoCodeInput.prop('disabled', false);
            $promoCode.val('');
            $button.text('Apply');

            if ($.isFunction(onChange)) {
                onChange();
            }
        } else {
            //apply code
            if ($promoCodeInput.val()) {
                $('.loader').removeClass('hidden');
                var request = Object.assign({ action: 'check_promo' }, get(), { promo: $promoCodeInput.val().toUpperCase() });

                $.post(AJAX_URL, request)
                    .done(function(response) {
                        if (response.valid) {
                            $promoCodeInput.val($promoCodeInput.val().toUpperCase());
                            $promoCode.val($promoCodeInput.val());
                            $promoCodeInput.prop('disabled', true);
                            $button.text('Remove');

                            if ($.isFunction(onChange)) {
                                onChange();
                            }
                        } else {
                            $error.removeClass('hide');
                        }
                    })
                    .fail(function() {
                        console.log('Check promo request error', request);
                    })
                    .always(function() {
                        $('.loader').addClass('hidden');
                    });
            }
        }
    });

    $('[name="promo_code_input"]').keyup(function(e) {
        if (e.keyCode == 13) {
            $('[data-role="toggle-promo-code"]').click();
        }
    });

    return {
        get: get,
        getDirectOfferCode: getDirectOfferCode,
        clearDirectOfferCode: clearDirectOfferCode,
        setOnChange: function(cb) {
            onChange = cb;
        }
    };
});